// src/components/common/ProtectedLayout.tsx
import React from "react";
import { Container, Box } from "@mui/material";
import Navigation from "./Navigation";
import NearbyShopAlert from "../customer/NearbyShopAlert";
import { useProximityAlert } from "../../hooks/useProximityAlert";
import { useAuth } from "../../contexts/AuthContext";

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  const { user } = useAuth();

  // Közelségi értesítések - csak bejelentkezett customer felhasználóknak
  const {
    nearbyShop,
    alertOpen,
    closeAlert,
    dismissForToday,
  } = useProximityAlert({
    enabled: user?.role === 'customer',
    maxDistance: 1000, // 1km
    checkInterval: 60000, // 1 percenként
  });

  return (
    <>
      <Navigation />
      <Container maxWidth="lg">
        <Box py={3}>{children}</Box>
      </Container>

      {/* Közelségi értesítés */}
      <NearbyShopAlert
        shop={nearbyShop}
        open={alertOpen}
        onClose={closeAlert}
        onDismissForToday={dismissForToday}
      />
    </>
  );
};

export default ProtectedLayout;

